import React from 'react';

const ShootingPreview5 = ({shooting}) => {

    const getBackgroundColor = (point) => {
        const distance = Math.sqrt((point.x - 50) ** 2 + (point.y - 50) ** 2);

        if (shooting.position === 'p') {
            if (distance < 17.2) return "bg-white";
        } else if (shooting.position === 's') {
            if (distance < 43.75) return "bg-white";
        }

        return "bg-[var(--dark-color)]";
    };

    return (
        <div className="border border-[var(--dark-color)] p-1 flex gap-1 bg-white">
            {shooting.points?.map((point) => (
                <div
                    key={`${point.id}-${point.x}-${point.y}`}
                    className={`border border-[var(--dark-color)] rounded-full w-2 h-2 ${getBackgroundColor(point)}`}
                ></div>
            ))}
        </div>
    );
};

export default ShootingPreview5;